import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export default function DatePickerModal({
    open,
    onClose,
    onConfirm,
    campanaRow,
}) {
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        setSelectedDate(
            campanaRow?.fecha_ultimo_cierre
                ? dayjs(campanaRow.fecha_ultimo_cierre)
                : null,
        );
    }, [campanaRow]);

    const handleConfirm = () => {
        onConfirm(selectedDate);
        onClose();
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
                <DialogTitle>Seleccionar fecha</DialogTitle>
                <DialogContent sx={{ marginTop: 2 }}>
                    <DatePicker
                        label="Fecha"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        displayWeekNumber
                        disableFuture
                        sx={{ marginTop: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        disabled={!selectedDate}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}
